import { 
    CREATEAMBULANCE, 
    CREATEAMBULANCECALL, 
    CREATEAMBULANCECALLTRANSACTION, 
    DELETEAMBULANCE, 
    DELETEAMBULANCECALL, 
    DELETEAMBULANCECALLTRANSACTION, 
    GETALLAMBULANCE, 
    GETALLAMBULANCECALL, 
    GETALLAMBULANCECALLTRANSACTION, 
    UPDATEAMBULANCE, 
    UPDATEAMBULANCECALL, 
    UPDATEAMBULANCECALLTRANSACTION 
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEAMBULANCE:
            return {
                ...state,
                    ambulanceSaveStatus: action.payload.success,
            }
        case GETALLAMBULANCE:
                return {
                        ...state,
                        ambulanceList: action.payload.data,
                        }
      
        case UPDATEAMBULANCE:
                return {
                        ...state,
                        ambulanceUpdateStatus: action.payload.success,
                        }   

        case DELETEAMBULANCE:
                 return {
                     ...state,
                     ambulanceDeleteStatus: action.payload.success,
                        } 
        case CREATEAMBULANCECALL:
            return {
                ...state,
                    ambulancecallSaveStatus: action.payload.success,
            }
        case GETALLAMBULANCECALL:
                return {
                        ...state,
                        ambulancecallList: action.payload.data,
                        }
      
        case UPDATEAMBULANCECALL:
                return {
                        ...state,
                        ambulancecallUpdateStatus: action.payload.success,
                        }   

        case DELETEAMBULANCECALL:
                 return {
                     ...state,
                     ambulancecallDeleteStatus: action.payload.success,
                        } 
        case CREATEAMBULANCECALLTRANSACTION:
            return {
                ...state,
                    ambulancecalltransactionSaveStatus: action.payload.success,
            }
        case GETALLAMBULANCECALLTRANSACTION:
                return {
                        ...state,
                        ambulancecalltransactionList: action.payload.data,
                        }
      
        case UPDATEAMBULANCECALLTRANSACTION:
                return {
                        ...state,
                        ambulancecalltransactionUpdateStatus: action.payload.success,
                        }   

        case DELETEAMBULANCECALLTRANSACTION:
                 return {
                     ...state,
                     ambulancecalltransactionDeleteStatus: action.payload.success,
                        } 
                     
                    default:
                        return state
                         }
                     }